var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PacemEllipseElement_1, PacemCircleElement_1;
import { CustomElement, Watch, PropertyConverters, P, Utils } from '@pacem/pacem-core';
import { Rect } from '@pacem/pacem-foundation';
import { ShapeElement } from './types';
import { TAG_MIDDLE_NAME } from './constants';
//namespace Pacem.Components.Drawing {
function full(c, rx, ry) {
    const d = 2 * rx, cx = c.x, cy = c.y;
    return {
        pathData: `M ${cx} ${cy} m ${-rx},0 a ${rx},${ry} 0 1,1 ${d},0 a ${rx},${ry} 0 1,1 ${-d},0`,
        vertices: [],
        boundingRect: { x: cx - rx, y: cy - ry, width: 2 * rx, height: 2 * ry }
    };
}
function sect(c, rx, ry, start, end) {
    const degToRad = Math.PI / 180;
    const s = degToRad * start, e = degToRad * end;
    //
    const polar = (theta) => rx * ry / Math.sqrt(Math.pow(Math.cos(theta) * ry, 2) + Math.pow(Math.sin(theta) * rx, 2));
    const rhoStart = polar(s), rhoEnd = polar(e);
    const cartesian = (rho, theta) => {
        return { x: rho * Math.cos(theta), y: rho * Math.sin(theta) };
    };
    const cartStart = cartesian(rhoStart, s), cartEnd = cartesian(rhoEnd, e);
    const p0 = { x: c.x + cartStart.x, y: c.y + cartStart.y }, p1 = { x: c.x + cartEnd.x, y: c.y + cartEnd.y };
    let boundingRect = Rect.expand(c, p0, p1);
    if (end < start)
        end += 360;
    if (start <= 0 && end > 0 || end >= 360) {
        boundingRect = Rect.expand(boundingRect, { x: c.x + rx, y: c.y });
    }
    if (start <= 90 && end > 90 || end >= 450) {
        boundingRect = Rect.expand(boundingRect, { x: c.x, y: c.y + ry });
    }
    if (start <= 180 && end > 180 || end >= 540) {
        boundingRect = Rect.expand(boundingRect, { x: c.x - rx, y: c.y });
    }
    if (start <= 270 && end > 270 || end >= 630) {
        boundingRect = Rect.expand(boundingRect, { x: c.x, y: c.y - ry });
    }
    const flag = e - s > Math.PI ? '1' : '0';
    return {
        pathData: `M ${p0.x} ${p0.y} A ${rx},${ry} 0 ${flag},1 ${p1.x},${p1.y} L ${c.x},${c.y} Z`, vertices: [p0, p1], boundingRect
    };
}
function getShapeGeometry(c, rx, ry, start, end) {
    start ??= 0, end ??= 0;
    start %= 360;
    end %= 360;
    while (start < 0)
        start += 360;
    while (end < start)
        end += 360;
    const threesixty = (start - end).isCloseTo(0);
    return threesixty ? full(c, rx, ry) : sect(c, rx, ry, start, end);
}
let PacemEllipseElement = PacemEllipseElement_1 = class PacemEllipseElement extends ShapeElement {
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first) {
            switch (name) {
                case 'center':
                case 'rx':
                case 'ry':
                case 'start':
                case 'end':
                    this.recomputeShape();
                    break;
            }
        }
    }
    getPathData() {
        const a = this.rx, b = this.ry, c = this.center, s = this.start ?? 0, e = this.end ?? 0;
        if (!Utils.isNull(c) && !Utils.isNull(a) && !Utils.isNull(b)) {
            return PacemEllipseElement_1.getPathData(c, a, b, s, e);
        }
        return null;
    }
    getShapeGeometry() {
        const center = this.center ?? { x: 0, y: 0 };
        const a = this.rx ?? 0, b = this.ry ?? 0;
        return getShapeGeometry(center, a, b, this.start, this.end);
    }
    static getPathData(c = { x: NaN, y: NaN }, rx = NaN, ry = NaN, start, end) {
        const { pathData } = getShapeGeometry(c, rx, ry, start, end);
        return pathData;
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Point })
], PacemEllipseElement.prototype, "center", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemEllipseElement.prototype, "rx", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemEllipseElement.prototype, "ry", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemEllipseElement.prototype, "start", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemEllipseElement.prototype, "end", void 0);
PacemEllipseElement = PacemEllipseElement_1 = __decorate([
    CustomElement({ tagName: P + '-' + TAG_MIDDLE_NAME + '-ellipse' })
], PacemEllipseElement);
export { PacemEllipseElement };
let PacemCircleElement = PacemCircleElement_1 = class PacemCircleElement extends ShapeElement {
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first) {
            switch (name) {
                case 'center':
                case 'radius':
                case 'start':
                case 'end':
                    this.recomputeShape();
                    break;
            }
        }
    }
    getPathData() {
        const r = this.radius, c = this.center;
        if (!Utils.isNull(c) && !Utils.isNull(r)) {
            return PacemCircleElement_1.getPathData(c, r, this.start, this.end);
        }
        return null;
    }
    getShapeGeometry() {
        const center = this.center ?? { x: 0, y: 0 };
        const r = this.radius ?? 0;
        return getShapeGeometry(center, r, r, this.start, this.end);
    }
    static getPathData(c = { x: NaN, y: NaN }, r = NaN, start, end) {
        return PacemEllipseElement.getPathData(c, r, r, start, end);
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Point })
], PacemCircleElement.prototype, "center", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemCircleElement.prototype, "radius", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemCircleElement.prototype, "start", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemCircleElement.prototype, "end", void 0);
PacemCircleElement = PacemCircleElement_1 = __decorate([
    CustomElement({ tagName: P + '-' + TAG_MIDDLE_NAME + '-circle' })
], PacemCircleElement);
export { PacemCircleElement };
